import BaseModelInstance from './base.model'
import { LeaderGoalCard as ModelDefinition } from './model-definitions'

class LeaderGoalCard extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default LeaderGoalCard
